import React from 'react';
import styled from 'styled-components';

interface BlockquoteProps {
  children: React.ReactNode;
  cite?: string;
  author?: string;
}

const SCBlockquote = styled.blockquote`
  position: relative;
  background-color: #494949;
  color: white;
  border-left: 15px solid #ccc;
  margin: 1rem 0;
  padding: 1rem 1rem 1rem 4em;
  border-radius: 5px;
  &::before {
    content: open-quote;
    font-size: 8em;
    position: absolute;
    top: -10px;
    left: 5px;
    pointer-events: none;
  }
  .signature {
    width: 100%;
    align-items: end;
    text-align: right;
    font-style: italic;
  }
`;

export function Blockquote(props: BlockquoteProps) {
  return (
    <SCBlockquote cite={props.cite}>
      {props.children}{' '}
      <div className="signature">
        <strong>{props.author}</strong>
      </div>
    </SCBlockquote>
  );
}
